import { APIContext } from "@certn/api";
import { css } from "@emotion/css";
import { useContext, useState } from "react";
import { useTimeout } from "usehooks-ts";

import constants from "../constants";

export function Debug() {
  const { domain } = useContext(APIContext);

  const [show, setShow] = useState(true);

  useTimeout(() => {
    setShow(false);
  }, 6000);

  if (constants.MODE === "production" || constants.SHOW_DEBUG === "false") {
    return null;
  }

  return (
    <div
      className={css(
        {
          position: "fixed",
          bottom: 0,
          right: 0,
          borderTopLeftRadius: 8,
          backgroundColor: "#00000066",
          transition: "500ms all",
          pointerEvents: "none",
        },
        !show && { opacity: 0 }
      )}
    >
      <div
        style={{
          padding: 8,
          color: "#ffffff",
          fontFamily: "monospace",
          textAlign: "right",
          fontWeight: "bold",
        }}
      >
        <div>{`${constants.MODE} build`}</div>
        <div>{`connected to ${domain}`}</div>
      </div>
    </div>
  );
}
